import React, { Fragment, useState, useEffect, useContext, useRef } from "react";

import { SessionContext } from '../context/sessionContext';

const Change_agenda = React.memo(() => { // { loadComentarios } //comentario, onComentarioChange, onFetchInitial
    //console.log("LOAD COMENTARIO", loadComentarios)

    const initialFetchDone = useRef(false); // Ref para controlar el fetch

    const { roleA } = useContext(SessionContext); //usuario
    //NOTA: NO usar "usuario" por ahora. Problema: en el context setUsuario se pasa a los componentes
    //El unico que lo cambia es "login". Por eso al recargar la pagina usuario es ""

    //const role = roleA?.roleA; //por ahora no usar
	const username = roleA?.username; //---> pasar el username (en la base 'name')
    //console.log("USERNAME", username )

    const [comentario, setComentario] = useState("");

    const [ultimoComentario, setUltimoComentario] = useState(null);
    const [maxComentario, setMaxComentario] = useState(5000);

    const [activo, setActivo] = useState(0);
    //const isMounted = useRef(false); // Ref para rastrear el montaje inicial

    const onChange = e => {
        setComentario(e.target.value);

        // Llamamos a la función de actualización del padre
        //onComentarioChange(e.target.value);
        setActivo(1)
    }

    const onSubmitForm = async e => {
		e.preventDefault();
		//console.log("LOGIN");
        const now = new Date().toISOString(); // Obtiene la fecha y hora actual en formato ISO 8601 (UTC)
        console.log(now);

		setActivo(1);
		try {
			const body = {  comentario, usuario: username, fecha: now }; //usuario,
			const response = await fetch(
				`/api/authentication/comentarios`,
				{
					method: "POST",
					headers: {
						"Content-type": "application/json"
					},
					body: JSON.stringify(body)
				}
			);			

			const parseRes = await response.json();
			
			if (response.ok) {
                console.log('Comentario guardado exitosamente');
                setComentario(''); // Limpiar el input después de guardar
                // Opcionalmente, podrías volver a cargar el último comentario aquí
                fetchUltimoComentario();
              } else {
                console.error('Error al guardar el comentario:', response.status);
              }
		} catch (error) {
			console.error('Error de red al guardar el comentario:', error);
		}
	};

    const fetchUltimoComentario = async (e) => {
        try {
            const response = await fetch('/api/api_serv/comentarios/ultimo');
            if (response.ok && response.status !== 204) {
                const data = await response.json();
                setUltimoComentario(data);
                //onComentarioChange(data.comentario); // Actualizar el estado del padre si es necesario
                setComentario(data.comentario); // Si quieres precargar el input con el último comentario
            } else if (response.status === 204) {
                console.log('No hay comentarios previos.');
            } else {
                console.error('Error al obtener el último comentario:', response.status);
            }
        } catch (error) {
            console.error('Error de red al obtener el último comentario:', error);
        }
    };

    useEffect(()=>{
		const maxComS = 5000;
		if(comentario){
			if(comentario !== "" || comentario !== null){
				var restantesR = maxComS - comentario.length;
				setMaxComentario(restantesR);
			}
		} else {
			setMaxComentario(maxComS);
		}
	}, [comentario]);

    useEffect(() => {       
        if (!initialFetchDone.current) {
            console.log("---->UNO<----- (Montaje y Visible)")
            fetchUltimoComentario();
            //onFetchInitial(); // Llamar a la función de fetch del padre al montar
            initialFetchDone.current = true; // Marca el componente como montado
        }
    }, []); // El array vacío asegura que esto se ejecute solo una vez al montar el componente 

    return (
        <>
            <div>

                {username==="javi1" && (
                    <div style={{ padding: "10px"}}>
                        <button className="btn btn-success btn-block"  onClick={e => fetchUltimoComentario(e)}>Actualizar</button>
                    </div>
                )}                 
                
                <form style={{ paddingLeft: "10px", paddingRight: "10px", height: '70%' }} onSubmit={onSubmitForm}>                                       
                    
                    <div className="input-container">                        
                        <textarea
                            type="text"
                            maxLength="5000"
                            name="datos_18_sintesis_nomenclatura"                            
                            rows={10}
                            style={{ width: '100%', height: '100%', boxSizing: 'border-box' }} 
                            value={comentario}
                            onChange={e => onChange(e)}                        
                        ></textarea>
                        
                        <p align="right" style={{ height: "5px", fontSize: "0.9em" }}>Caracteres restantes: {maxComentario}</p>
                    </div>{/*cierra ---> input-container */}                                     

                    <button className="btn btn-success btn-block" disabled={activo === 0 ? true : false} >Guardar</button>

                    <div>
                        {ultimoComentario && (
                        <div style={{ height: "5px", fontSize: "0.9em" }}>
                            <p>Usuario: {ultimoComentario.usuario} 
                            (
                                {new Date(ultimoComentario.fecha).toLocaleString(undefined, {
                                    day: '2-digit',
                                    month: '2-digit',
                                    year: 'numeric',                                    
                                    
                                    hour: '2-digit',
                                    minute: '2-digit',
                                    second: '2-digit', // Opcional: para incluir segundos
                                    hour12: false // Fuerza el formato de 24 horas
                                })}
                            )
                            </p>
                        </div>
                    )}
                    </div>

                </form>
            </div>

        </>
    )
});

export default Change_agenda;

